// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="december-6%2C-2019">December 6, 2019</h2>
      <p>The Veterans Integrated Service Network (VISN) identifier for each health facility is now available.</p>
      <ul>
      <li><code>visn</code> has been added to all <code>/facilities</code> endpoints. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3609">View code change(s)</a></li>
      <li>For non-health facilities, this will return as <code>null</code>.</li>
      </ul>
      <hr />
      <h2 id="november-8%2C-2019">November 8, 2019</h2>
      <p>The <code>/nearby</code> endpoint received major changes.</p>
      <ul>
      <li>Previously, the server retrieved an isochrone (a line connecting points of the same time) for a provided location and looked for facilities that fell within that polygon. Now the opposite is true: facilities have isochrones that are compared against the provided location. Users should see increased performance from this endpoint as a result.</li>
      <li>Data about drive times now comes directly from the Veterans Health Administration (VHA). Responses may vary slightly from the previous implementation because of this switch.</li>
      <li>The response schema has also changed. Instead of returning facility data from <code>/nearby</code>, the endpoint now provides <code>min_time</code> and <code>max_time</code> attributes for the matching polygons and links to endpoints that can be queried to retrieve full information about the associated facility. This schema change allows us to keep <code>/nearby</code> within v0 of the Facilities API instead of incrementing to v1. See the schema changes by <a href="https://developer.va.gov/explore/facilities/docs/facilities">visiting the documentation</a>.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3512">View code change(s)</a></p>
      <hr />
      <h2 id="october-23%2C-2019">October 23, 2019</h2>
      <p>When including latitude and longitude parameters in a request to  <code>/facilities</code> the results are now sorted in ascending order by distance.</p>
      <ul>
      <li>Previously the facilities in the response were sorted by type first and then distance. Now the closest facilities to the requested location will be returned first regardless of type. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3461">View code change(s)</a></li>
      </ul>
      <hr />
      <h2 id="september-30%2C-2019">September 30, 2019</h2>
      <p>You can now see if Health facilities are mobile or temporarily deactivated.</p>
      <ul>
      <li>Added <code>mobile</code> and <code>active_status</code> flags to the API response for Health facilities (other facility types will return <code>null</code> for these fields). Options for <code>mobile</code> are <code>true</code> or <code>false</code>; options for <code>active_status</code> are <code>A</code> for Active or <code>T</code> for Temporarily deactivated. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3339/commits">View code change(s)</a>
      <ul>
      <li>Mobile facilities are subject to frequent address changes. To get the exact current location, please call the number listed.</li>
      </ul>
      </li>
      </ul>
      <hr />
      <h2 id="september-20%2C-2019">September 20, 2019</h2>
      <p>You can now query facilities in <code>/nearby</code> using latitude and longitude</p>
      <ul>
      <li>As an alternative option to <code>address</code>, this adds the ability to make a request to <code>/va_facilities/v1/nearby</code> using <code>lat</code> and <code>lng</code> as input parameters. <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3273/commits">View code change(s)</a></li>
      </ul>
      <hr />
      <h2 id="june-17%2C-2019">June 17, 2019</h2>
      <p>Get nearby facilities for an address <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/3084">#3084</a></p>
      <ul>
      <li><code>/nearby</code>, the first available endpoint for v1 of Facilities API, returns all facilities within a provided drive time for an address</li>
      <li>v1 changes
      <ul>
      <li>Changed <code>long</code> to <code>lng</code> to accommodate typed languages <a href="https://github.com/department-of-veterans-affairs/vets-api-clients/issues/15">#15</a></li>
      <li>Wait times are now nested in the Health services array</li>
      </ul>
      </li>
      </ul>
      <hr />
      <h2 id="april-26%2C-2019">April 26, 2019</h2>
      <p>Get facilities by state <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2992">#2992</a></p>
      <ul>
      <li>Facilities endpoint now accepts <code>state</code> as a parameter. This returns all facilities in a particular state/territory.</li>
      </ul>
      <hr />
      <h2 id="april-25%2C-2019">April 25, 2019</h2>
      <p>Get facilities by zip <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2987">#2987</a></p>
      <ul>
      <li>Facilities endpoint now accepts <code>zip</code> as a parameter. This returns all facilities in a particular zip code.</li>
      </ul>
      <hr />
      <h2 id="april-18%2C-2019">April 18, 2019</h2>
      <p>Fix error when returning CSV <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2974">#2974</a></p>
      <ul>
      <li>The <code>/facilities/all</code> endpoint no longer returns a 500 status code when a user requests <code>text/csv</code></li>
      </ul>
      <hr />
      <h2 id="february-13%2C-2019">February 13, 2019</h2>
      <p>Standardize closed days to &quot;Closed&quot; in Facilities API <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2802">#2802</a></p>
      <ul>
      <li>Changes any casing of &quot;closed&quot; and &quot;-&quot; to &quot;Closed&quot; for a consistent convention in the Facilities API</li>
      </ul>
      <hr />
      <h2 id="january-16%2C-2019">January 16, 2019</h2>
      <p>Fix facilities api bugs <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2735">#2735</a></p>
      <ul>
      <li>Allows users to pass both a list of IDs and a lat/long in the same request.</li>
      <li>Populate missing location data in NCA, VBA, and VC facilities, <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2735/files#diff-a0253f0a6c07463fb11a513df82f21d2">view specific change</a>.</li>
      </ul>
      <hr />
      <h2 id="december-26%2C-2018">December 26, 2018</h2>
      <p>Remove community care providers from all facilities search <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2582">#2582</a></p>
      <ul>
      <li>Reverts back to the old functionality, removing community care providers from the all facility search</li>
      <li>Community care providers can now only be searched by passing <code>type=cc_provider</code> into the search endpoint</li>
      </ul>
      <hr />
      <h2 id="november-20%2C-2018">November 20, 2018</h2>
      <p>Add facilities distances <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2687">#2687</a></p>
      <ul>
      <li>Adds distance to meta property of lat/long inquiries to the Facilities API and adds documentation for the meta property</li>
      <li>Facility distances from lat/long point are returned in responses</li>
      </ul>
      <hr />
      <h2 id="november-12%2C-2018">November 12, 2018</h2>
      <p>Community care provider searches <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/2405">#2405</a></p>
      <ul>
      <li>This enhances the facilities search endpoint to include community care providers in the search by default</li>
      <li>Additionally, it supports searching for just community care  providers by passing <code>type=cc_provider</code> into the search endpoint</li>
      </ul>
      <hr />
      <h2 id="august-13%2C-2018">August 13, 2018</h2>
      <p>Launch of the VA Facilities API</p>
      <ul>
      <li>VA_Facilities API endpoint for external API consumers. Supports json/<a href="http://geojson.org/">geojson</a> results and a bulk &quot;get all&quot; endpoint in geojson and csv format.</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
